export default __webpack_public_path__ + "static/media/image1.4ea65a69.png";